import { Checkbox } from "@progress/kendo-react-inputs";

function ShowCell({ hidden, dataItem, onToggleShow }) {
    function handleToggleShow() {
        onToggleShow(dataItem.id);
    };

    return (
        <td style={{ width: "30px" }}>
            <Checkbox
                disabled={hidden}
                onClick={handleToggleShow}
                checked={dataItem.show}
            />
        </td>
    );
}

export default ShowCell;